import styled from "styled-components";

export const Content = styled.div``;

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-flow: row;
  height: calc(100vh - 90px); /* Replace */
`;